var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    title: _vm.title
  }, false), [_c('v-layout', {
    staticClass: "fill-height d-flex flex-column",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('sign-head', _vm._b({
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, 'sign-head', {
    contract: _vm.form
  }, false)), _c('v-divider'), _c('div', {
    staticStyle: {
      "flex": "1",
      "overflow": "hidden"
    }
  }, [_c('sign-tabs', _vm._b({
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var prev = _ref.prev,
          next = _ref.next;
        return [_c('tabs-view', _vm._g({
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v;
            },
            expression: "form"
          }
        }, {
          exit: _vm.exit,
          next
        })), _c('tabs-form', _vm._g({
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v;
            },
            expression: "form"
          }
        }, {
          prev,
          next
        })), _c('tabs-file', _vm._g({
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v;
            },
            expression: "form"
          }
        }, {
          prev,
          next
        })), _c('tabs-save', _vm._g({}, {
          prev,
          save: _vm.save
        })), _c('tabs-done', _vm._g({}, {
          exit: _vm.exit
        }))];
      }
    }]),
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, 'sign-tabs', {
    contract: _vm.form
  }, false))], 1), _c('client-loader', _vm._b({}, 'client-loader', {
    loading: _vm.loading
  }, false))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }